module.exports = "/assets/src/components/ChristmasOfferPopIn/benlux-offre-noel-pop-up.png";